module.exports = __webpack_public_path__ + "img/blog-2.933734e5.png";